import { stringify } from 'query-string';

const externalService = window.APP.apiURL;
const PREFIX_URL = `${externalService}/government-revenues`;
const BUKA20_PREFIX_URL = process.env.API_VPNONTRADER_HOST;

const BILLING_SCOPE = 'payment.*.*';

export default {
  getInfo() {
    return this.get(`${PREFIX_URL}/info`, 'user', { responseErrorJson: true });
  },
  getInfoBuka20(productType = 'government-revenue') {
    return this.get(`${BUKA20_PREFIX_URL}/v1/customer-products`, 'user', {
      responseErrorJson: true,
      enableAuthHeader: true,
      params: { product_type: productType },
    });
  },
  inquiry(data) {
    return this.post(`${PREFIX_URL}/inquiries`, 'user', { data, responseErrorJson: true });
  },
  inquiryBuka20(data) {
    return this.post(`${BUKA20_PREFIX_URL}/v2/customer/transactions/inquiry`, 'user', {
      data,
      responseErrorJson: true,
      enableAuthHeader: true,
    });
  },
  createTransaction(data) {
    return this.post(`${PREFIX_URL}/transactions`, 'user', { data, responseErrorJson: true });
  },
  createTransactionBuka20(data) {
    return this.post(`${BUKA20_PREFIX_URL}/v2/customer/transactions`, 'user', {
      data,
      responseErrorJson: true,
      enableAuthHeader: true,
    });
  },
  getTransaction(id) {
    return this.get(`${PREFIX_URL}/transactions/${id}`, 'public', { responseErrorJson: true });
  },
  getTransactionBuka20(id) {
    return this.get(
      `${BUKA20_PREFIX_URL}/v2/customer/transactions/government-revenue/${id}?with_product_metadata=true`,
      'user',
      {
        responseErrorJson: true,
        enableAuthHeader: true,
      }
    )
  },
  getReceiptPdf(id) {
    return this.get(`${PREFIX_URL}/transactions/${id}/receipts`, 'public', {
      responseErrorJson: true,
    });
  },
  getFeeConfigs(params) {
    const requestPayload = {
      payment_methods: params.paymentTypes,
      metadata: JSON.stringify({ product_type: params.productType }),
    };
    // can't pass requestPayload to api option as it generate query 'payment_methods[]'
    // while the api require query 'payment_methods' (without[])
    return this.get(
      `${BUKA20_PREFIX_URL}/v1/payment/billings/fee-configs?${stringify(requestPayload)}`,
      BILLING_SCOPE,
      {
        responseErrorJson: true,
        enableAuthHeader: true,
      }
    );
  },
};
